import { Component } from 'react';
import { isTrue } from '../../../../helpers/isTrue';
import { getUpgradeUrl } from '../../../../helpers/upgradeUrl';
import ConfirmationModal from '../../../../components/Modals/ConfirmationModal';
import { withTranslation } from 'react-i18next';
import moment from 'moment';

class Plan extends Component {
    constructor() {
        super();
        this.license = window.license ?? {};
        this.reactivate = this.reactivate.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.deactivate = this.deactivate.bind(this);

        this.is_not_viewer = window.is_not_viewer;
        this.state = {
            disableBtn: false,
            isOpen: false,
            sub_status: '',
            statusExist: false,
        };
    }

    async componentDidMount() {
        try {
            const res = await fetch('/customers/account-status/', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': '{{csrf_token}}',
                },
            });
            const data = await res.json();
            this.setState({
                statusExist: true,
                sub_status: data?.sub_status,
            });
        } catch (err) {
            console.log(err);
        }
    }

    async reactivate() {
        try {
            this.setState({
                disableBtn: true,
            });
            const link = `/customers/licenses/${this.license.license_id}/reactivate/`;
            await fetch(link);
            window.location.reload();
        } catch (err) {
            window.location.reload();
        }
    }

    async deactivate() {
        const link = document.createElement('a');
        link.href = `/customers/user-cancellation/${this.license.license_id}/`;
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    onOpenModal() {
        this.setState({ isOpen: true });
    }

    onCloseModal() {
        this.setState({ isOpen: false });
    }

    render() {
        const { t } = this.props;

        const message = (
            <div>
                <div className="mb-10">{t('settings.plan.message.message1')}</div>
                <div className="mb-10">
                    {t('settings.plan.message.message2')}{' '}
                    <strong>{t('settings.plan.message.message3')}</strong>
                </div>
                <div className="mb-10">
                    {t('settings.plan.message.message1')}{' '}
                    <strong>{t('settings.plan.message.message5')} </strong>
                    {t('settings.plan.message.message6')}
                </div>
                {t('settings.plan.message.message7')}
            </div>
        );
        return (
            <>
                <div className="settings-plan">
                    <div className="settings-plan-header">
                        <div className="settings-plan-header-title">
                            {t('settings.plan.current_plan')}
                        </div>
                        {this.is_not_viewer && this.license?.license_id && (
                            <div className="settings-plan-header-btns">
                                {isTrue(this.props.is_deactivated) ? (
                                    <>
                                        <a
                                            className="settings-secondary-btn"
                                            href={getUpgradeUrl(
                                                '/customers/change_plan/?reactivation=true',
                                            )}
                                        >
                                            {t('settings.plan.reactivate')}
                                        </a>
                                        {this.props.customer_id !== 'False' && (
                                            <a
                                                className="settings-secondary-btn"
                                                href={`/settings/payment-methods/${this.props.customer_id}`}
                                            >
                                                {t('settings.plan.payment_methods')}
                                            </a>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <a
                                            className="settings-secondary-btn"
                                            href="#"
                                            role="button"
                                            id="dropdownMenuLink"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <button className="btn-icon d-flex">Billing</button>
                                        </a>
                                        <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuLink"
                                        >
                                            <li>
                                                <a
                                                    className="dropdown-item cursor-pointer"
                                                    href={'/customers/licenses/'}
                                                >
                                                    {t('settings.plan.billing_history')}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="dropdown-item cursor-pointer"
                                                    href={getUpgradeUrl('/customers/change_plan/')}
                                                >
                                                    {t('settings.plan.change_plan')}
                                                </a>
                                            </li>
                                            {isTrue(this.props.cancel_at_period_end) ? (
                                                <li>
                                                    <a
                                                        className="dropdown-item cursor-pointer"
                                                        href={
                                                            '/customers/change_plan/?cancellation=true'
                                                        }
                                                    >
                                                        {t('settings.plan.deactivate')}
                                                    </a>
                                                </li>
                                            ) : (
                                                this.state.statusExist && (
                                                    <li>
                                                        {window.user_permissions
                                                            ?.subscription_status === 'trialing' ? (
                                                            <a
                                                                className="dropdown-item cursor-pointer"
                                                                href={
                                                                    '/customers/change_plan/?cancellation=true'
                                                                }
                                                            >
                                                                {t('settings.plan.deactivate')}
                                                            </a>
                                                        ) : (
                                                            <a
                                                                className="dropdown-item cursor-pointer"
                                                                href={
                                                                    '/customers/change_plan/?cancellation=true'
                                                                }
                                                            >
                                                                {t('settings.plan.deactivate')}
                                                            </a>
                                                        )}
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="settings-plan-content">
                        {this.license.license_id ? (
                            <>
                                <div className="settings-plan-content-left">
                                    <div className="settings-plan-content-left-header">
                                        {this.license.license_product_name}
                                        <div className="settings-plan-content-left-tag">
                                            {this.license.tag_1}
                                        </div>
                                        <div className="settings-plan-content-left-tag">
                                            {this.license.tag_2}
                                        </div>
                                    </div>
                                    {window.user_permissions?.trial_end && (
                                        <div className="settings-plan-content-left-bottom">
                                            {t('settings.plan.trial_end')}{' '}
                                            <span>
                                                {moment(window.user_permissions?.trial_end).format(
                                                    'MMMM DD YYYY HH:mm',
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    {isTrue(this.props.cancel_at_period_end) && (
                                        <div className="settings-plan-content-left-bottom">
                                            {t('settings.plan.no_licenses')}{' '}
                                            <span>{this.props.cancel_in}</span>
                                        </div>
                                    )}
                                </div>
                                {isTrue(this.props.cancel_at_period_end) && (
                                    <div className="settings-plan-content-right">
                                        <a
                                            className="button button-filled button-primary"
                                            href={getUpgradeUrl(
                                                '/customers/change_plan/?reactivation=true',
                                            )}
                                        >
                                            {t('settings.plan.reactivate')}
                                        </a>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="settings-plan-content-left-bottom">
                                {' '}
                                {t('settings.plan.message.message8')}
                            </div>
                        )}
                    </div>
                </div>
                <ConfirmationModal
                    isOpen={this.state.isOpen}
                    message={message}
                    onClose={this.onCloseModal}
                    onSubmit={this.deactivate}
                    cancleBtn={t('settings.plan.cancleBtn')}
                    buttonName={t('settings.plan.buttonName')}
                />
            </>
        );
    }
}

export default withTranslation()(Plan);
